import React from 'react';
import { Modal, Form, Input, Button, message } from 'antd';

interface IProps {
  showModal: boolean;
  closeModal(): void;
  onModalOk(values: any): void;
};

function SearchModal(props: IProps) {
  const { showModal, closeModal, onModalOk } = props;
  const [ form ] = Form.useForm();

  // 完成
  const onFinish = (values: any) => {
    console.log(values);
    Object.keys(values).forEach(key => {
      if (!values[key]) {
        values[key] = "";
      }
    });
    onModalOk(values);
  }
  // 未完成
  const onFinishFailed = () => {
    message.info("请完善信息！");
  }
  // 验证身份证
  const validateIdcard = (rule: any, value: any, callback: any) => {
    let regular: any = /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
    if (value && !regular.test(value)) {
      callback('请输入正确的身份证号');
    } else {
      callback();
    }
  }
  const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 16 },
  };
  const tailLayout = {
    wrapperCol: { offset: 6, span: 16 },
  };
  return (
    <Modal
      visible={showModal}
      title="证书查询"
      footer={null}
      onCancel={closeModal}
    >
      <Form {...layout} form={form} onFinish={onFinish} onFinishFailed={onFinishFailed}>
        {/* {validator: validateIdcard} */}
        <Form.Item name="id_card" label="身份证号" rules={[{ required: true }, {validator: validateIdcard}]}>
          <Input allowClear placeholder="请输入身份证号" />
        </Form.Item>
        <Form.Item name="cert_number" label="证书编号" rules={[{ required: false }]}>
          <Input allowClear placeholder="请输入证书编号" />
        </Form.Item>
        <Form.Item {...tailLayout}>
          <Button type="primary" htmlType="submit">
            查询
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default SearchModal;

